import { UtilityServices } from './../../../../Services/utility.services';
import { progressStepNames } from './../../../../Models/progress-bar-step';
import { SecureStorageService } from './../../../../Services/secure-storage.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppsettingService } from '../../../../Services/appsetting.service';
import { applicationPaths, localStorageKeys, screenDetails } from '../../../../Models/configurations';
import { CheckInDataService } from 'projects/Check-In/src/app/Services/check-in-data.service';
@Component({
  selector: 'app-six-step',
  templateUrl: './six-step.component.html',
  //styleUrls: ['./six-step.component.css']
})
export class SixStepComponent implements OnInit {
  urlName: string;
  isSendMessage = false;
  isNotificationforservice = false;
  private offerValue: boolean = false;
  public steps: any;
  public activeStepName: string;
  public activeStepCompleted: boolean;

  constructor(
    private readonly appsettingService: AppsettingService,
    private readonly utilityService: UtilityServices,
    private readonly secureStorageService: SecureStorageService,
    private cdrf: ChangeDetectorRef,
    private readonly checkInDataService: CheckInDataService
  ) {
    if (this.secureStorageService.getKeyData(localStorageKeys.stepStatus) !== undefined) {
      this.steps = this.secureStorageService.getKeyData(localStorageKeys.stepStatus);
    }

  }

   contactUser(Value: boolean) {
      this.offerValue = !Value;
    const offerDetail = {
      offerDetails: this.offerValue
    };
    this.secureStorageService.setKeyData(localStorageKeys.offerValueDetails, offerDetail);
  }
 
  public moveNext(): void {
    this.urlName = this.appsettingService.getScreenConfiguration(screenDetails.stepSix);
    this.activeStepCompleted = true;
    this.activeStepName = progressStepNames.stepName3;
    this.appsettingService.stepCompletion(this.activeStepName, this.activeStepCompleted);
    this.steps = this.secureStorageService.getKeyData(localStorageKeys.stepStatus);
    this.cdrf.detectChanges();
    this.utilityService.navigateToNext(this.urlName);
  }

  notifyUser(Value: boolean) {
    this.isSendMessage = !Value;
    const notify = {
      notifyUser: this.isSendMessage
    };
    this.secureStorageService.setKeyData(localStorageKeys.notifyUserDetails, notify);
  }

  ngOnInit(): void {
    this.checkInDataService.GetCheckInModuleData().subscribe(data => {
      if (data) {
        if (data['isCheckInNotAllowed']) {
          this.utilityService.navigateToNext('/' + applicationPaths.seven);
        }
      }
    });
  }
}